module.exports = __webpack_public_path__ + "static/media/phone_Profession.4c42cc01.png";